<template>
  <WFApp id="app" class="h-full w-full justify-even overflow-hidden"
    @screensaving="screensaving"
  >
    <div class="w-full h-full flex flex-col justify-stretch">
      <LandscapeHeader class="basis-106 w-full grow-0 shrink-0 overflow-hidden"></LandscapeHeader>
      <div class="grow overflow-hidden">
         <WFTabs :activeTab="currentTab" class="grow tabs">
          <WFTab name="map">
            <MapPage @loaded="mapLoaded" @closeSidebar="closeSidebar"></MapPage>
          </WFTab>
          <WFTab name="esileht">
            <Homepage></Homepage>
          </WFTab>
          <WFTab name="pakkumised">
            <Pakkumised></Pakkumised>
          </WFTab>
          <WFTab name="news">
            <News></News>
          </WFTab>
          <WFTab name="giftcard">
            <Giftcard></Giftcard>
          </WFTab>
          <WFTab name="search">
            <Search @clicked="poiClicked"></Search>
          </WFTab>
          <WFTab name="shops">
            <GroupMenu @clicked="poiClicked" slug="shops"></GroupMenu>
          </WFTab>
          <WFTab name="dine">
            <GroupMenu @clicked="poiClicked" slug="dine"></GroupMenu>
          </WFTab>
          <WFTab name="bustimes">
            <BusTimes></BusTimes>
          </WFTab>
        </WFTabs>
      </div>
      <div class="w-full basis-100">
          <MainMenu ref="menu" class="w-full h-full"></MainMenu>
      </div>
    </div>
    <WFBanner
      class="banners-screensaver portrait:hidden"
      :qrURL="qrURL"
      template="default"
      v-show="screensaver && isScreensaver('screensaver') && !mobile"
      container="screensaver"
      @clicked="hideBanner"
      @hasbanners="hasBanners"
    ></WFBanner>
    <WFBanner
      class="banners-screensaver landscape:hidden"
      :qrURL="qrURL"
      template="default"
      v-show="screensaver && isScreensaver('screensaver-portrait') && !mobile"
      container="screensaver-portrait"
      @clicked="hideBanner"
      @hasbanners="hasBanners"
    ></WFBanner>
  </WFApp>
</template>

<script>
import { mapState } from "vuex";

import { WFTabs, WFTab } from "@3dwayfinder/wayfinder-vue-components";

import MapPage from "./components/MapPage.vue";
import MainMenu from "./components/MainMenu.vue";
import LandscapeHeader from "./components/LandscapeHeader.vue";
import Search from "./components/Search.vue";
import Pakkumised from "./components/Pakkumised.vue";
import GroupMenu from "./components/GroupMenu.vue";
import Homepage from "./components/Homepage.vue";
import News from "./components/News.vue";
import Giftcard from "./components/Giftcard.vue";
import BusTimes from "./components/BusTimes.vue";

const builtInClasses = ["columns-2", "columns-3"];

export default {
  name: "App",
  components: {
    MapPage,
    LandscapeHeader,
    Search,
    Pakkumised,
    WFTabs,
    WFTab,
    MainMenu,
    GroupMenu,
    Homepage,
    News,
    Giftcard,
    BusTimes
  },
  computed: {
    ...mapState("wf", ["pages", "portrait", "landscape", "mobile", "pois"]),
    ...mapState(["currentPOI", "currentPage", "currentTab", "searchVisible", "goback", "currentOffer"]),
    
    
    isLocalhost() {
      return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    }
  },
  data() {
    return {
      pageSlug: "map",
      infoPage: null,
      screensaver: false,
      hasScreensaver: {},
      qrURL:
        "https://clients.3dwayfinder.com/Terkanten/?kiosk={kiosk}&map2DRotation={rot}",
    
      settingsData: {
        colors: {
          'primary': '#47C5FF',          
          'primary-content': '#333333',   
          'secondary': '#FFFFFF',         
          'secondary-content': '#FFFFFF', 
          'accent': '#333333',           
          'accent-content': '#333333',    
          'base': '#FFFFFF',              
          'base-content': '#333333',     
          'neutral': '#FFFFFF',           
          'neutral2': '#FBF9F9',          
          'border': '#EFE9E4',           
        }
      }
    };
  },
  watch: {
    currentTab () {
      if (this.currentTab === "map") {
        this.$wayfinder.run();
      }
      else {
        this.$wayfinder.pause();
      }
    },
    pages() {
      this.setPageBySlug("");
      this.$nextTick(() => {
        this.setPageBySlug("map");
      });
    },
    searchVisible() {
      if (this.searchVisible) {
        this.currentTab = "search";
      } else {
        this.currentTab = "grouppois";
      }
    },
    goback() {
      this.closeSidebar()
    },
  },
  mounted() {
    console.log("mounted", builtInClasses);
    
    
    if (this.isLocalhost) {
      this.applyColorSettings();
      console.log('🎨 Mock colors applied for localhost');
    }
  },
  methods: {
    
    
    loadSettings() {
      if (this.isLocalhost) {
        console.log('📋 Using mock colors for localhost - skipping CMS load');
        return;
      }
      
      try {
        const wf = this.$wayfinder;
        
        if (!wf) {
          console.warn('⚠️ Wayfinder instance not found, using default settings');
          return;
        }
        
        if (!wf.settings) {
          console.warn('⚠️ Wayfinder settings not available, using default settings');
          return;
        }
        
        
       
        if (typeof wf.settings.getColor === 'function') {
          console.log('🔍 getColor method exists, testing it:', wf.settings.getColor('template.color.primary'));
        } else {
          console.log('⚠️ getColor method does NOT exist on wf.settings');
        }
        
        const getColorValue = (key, fallback) => {
          const value = wf.settings[key];
          if (value) {
           
            if (typeof value.toHex === 'function') {
              return value.toHex();
            }
            
            if (typeof value === 'string') {
              return value;
            }
          }
          return fallback;
        };
        
        this.settingsData.colors = {
          'primary': getColorValue('template.color.primary', '#47C5FF'),
          'primary-content': getColorValue('template.color.primary-content', '#333333'),
          'secondary': getColorValue('template.color.secondary', '#FFFFFF'),
          'secondary-content': getColorValue('template.color.secondary-content', '#FFFFFF'),
          'accent': getColorValue('template.color.accent', '#333333'),
          'accent-content': getColorValue('template.color.accent-content', '#333333'),
          'base': getColorValue('template.color.base-100', '#FFFFFF'),
          'base-content': getColorValue('template.color.base-content', '#333333'),
          'neutral': '#FFFFFF',
          'neutral2': '#FBF9F9',
          'border': '#EFE9E4',
        };
        
        console.log('🎨 Colors loaded from CMS:', this.settingsData.colors);
        
      } catch (error) {
        console.error('❌ Error loading settings:', error);
        console.warn('Using default settings due to error');
      }
    },
    
    /**
     * Apply color settings as CSS variables to the document root
     */
    applyColorSettings() {
      const colors = this.settingsData.colors;
      const root = document.documentElement;
      
    
      root.style.setProperty('--th-primary', colors['primary']);
      root.style.setProperty('--th-primary-content', colors['primary-content']);
      root.style.setProperty('--th-secondary', colors['secondary']);
      root.style.setProperty('--th-secondary-content', colors['secondary-content']);
      root.style.setProperty('--th-accent', colors['accent']);
      root.style.setProperty('--th-accent-content', colors['accent-content']);
      
      
      root.style.setProperty('--th-active', colors['primary']);
      root.style.setProperty('--th-active-content', colors['primary-content']);
      
     
      root.style.setProperty('--th-base', colors['base']);
      root.style.setProperty('--th-base-content', colors['base-content']);
      root.style.setProperty('--th-neutral', colors['neutral']);
      root.style.setProperty('--th-neutral2', colors['neutral2']);
      root.style.setProperty('--th-border', colors['border']);
      
      console.log('🎨 Colors applied - Primary/Active:', colors['primary']);
      
    
      console.log('🔍 Verify --th-active:', getComputedStyle(root).getPropertyValue('--th-active'));
    },
    
    setPage(page) {
      this.pageSlug = page.slug;
      this.$store.dispatch("setPage", page);

      if (page.slug !== "map") {
        this.$store.dispatch("set360", "");
      }
    },
    setPageBySlug(slug) {
       console.log('setPageBySlug', slug)
      this.$store.dispatch("setTab", slug);
    },
    infoPageClicked(page) {
      this.infoPage = page;
      this.pageSlug = "info-page";
    },
    poiClicked(poi) {
      if (poi) {
        this.setPageBySlug("map");
       
       
        this.$wayfinder.clearHighlights();
        this.$wayfinder.setHighlights([poi]);

        if (poi.getNode() && poi.getNode().id) {
          console.log('poi.getNode', typeof poi.getNode())
          this.$wayfinder.showFloor(poi.getNode().getFloor());
        }

        this.setPOI(poi);
      }
    },
    setPOI(poi) {
      this.$store.dispatch("setPOI", poi);
      this.$store.dispatch("setNavbar", true);
    },
    closeSidebar () {
      this.$store.dispatch("setPOI", null);
      this.$store.dispatch("setNavbar", false);
      this.$store.dispatch("set360", "");
    },
    screensaving() {
      this.infoPage = null;
      this.pageSlug = "map";
      this.setPageBySlug("map");
      this.$store.dispatch("clearNav");
      this.$nextTick(() => {
        this.$wayfinder.pause();
      });
      
      this.screensaver = true;
    },
    mapLoaded() {
      this.$wayfinder.options.idleFrameLimit = 2;
      this.$nextTick(() => {
        
        this.$wayfinderApp.loadPages();
      
        // Load settings from CMS and apply colors
        this.loadSettings();
        this.applyColorSettings();
        
        // Apply colors to map icons
        this.applyMapIconColors();

        setTimeout(()=> {
          this.$store.dispatch("getOffers", {"project": this.$wayfinder.options.project, "pois": this.pois});
          this.$store.dispatch("getNews", this.$wayfinder.options.project);
        }, 500)
      })

      this.setPageBySlug("map");
      
      // DEBUG: Log current CSS variable state after everything is loaded
      setTimeout(() => {
        const root = document.documentElement;
        console.log('🔍 FINAL CHECK - CSS Variables:');
        console.log('  --th-active:', getComputedStyle(root).getPropertyValue('--th-active'));
        console.log('  --th-primary:', getComputedStyle(root).getPropertyValue('--th-primary'));
      }, 1000);
    },
    
    /**
     * Apply primary color to map icons (markers, highlights, etc.)
     */
    applyMapIconColors() {
      try {
        const wf = this.$wayfinder;
        const primaryColor = this.settingsData.colors['primary'];
        
        if (wf) {
          // POI marker/pin color
          if (wf.settings) {
            wf.settings.set('map.poi.markerColor', primaryColor);
            wf.settings.set('map.poi.iconBackgroundColor', primaryColor);
            wf.settings.set('map.icons.backgroundColor', primaryColor);
            wf.settings.set('map.floor.labelBackgroundColor', primaryColor);
          }
          
          // If Wayfinder has a setIconColor or similar method
          if (wf.setIconColor) {
            wf.setIconColor(primaryColor);
          }
          
          // Update highlight color for selected POIs
          if (wf.options) {
            wf.options.highlightColor = primaryColor;
          }
          
          console.log('🗺️ Map icon colors set to:', primaryColor);
        }
      } catch (error) {
        console.log('Could not set map icon colors via API:', error);
      }
    },
    hasBanners(has, template, container) {
      this.hasScreensaver[container] = has;
    },
    isScreensaver(container) {
      return this.hasScreensaver[container];
    },
    hideBanner() {
      this.screensaver = false;
    },
    touched() {
      this.$store.dispatch("pushLog", "Touch");
    },
  },
};
</script>

<style lang="postcss">
.info-menu .wf-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: auto;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  font-size: 2.4rem;
  width: min-content;
}

.info-menu {
  padding: 2rem;
}

.info-menu .wf-list-item {
  background-color: white;
  display: flex;
  min-width: 32ch;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 2rem;
  padding: 1em;
}

.info-menu .wf-icon {
  width: 6rem;
  height: 6rem;
  margin-right: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-menu .wf-icon svg {
  height: 6rem;
  margin-bottom: 0;
}

.banners-screensaver {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background-image: url("./assets/logo.png");
  background-size: 20%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-color: white;
  z-index: 99;
}

.tabs {
  background-image: url("@/assets/main_bg.svg");
  background-size: cover;
}
</style>